import Mustache from "mustache";

window.Mustache = Mustache;
